'use client';

import { useEffect, useState } from 'react';

function detectPreviewCanvas(): boolean {
  try {
    if (typeof document === 'undefined') return false;
    return Boolean(document.querySelector('[data-preview-canvas="true"]'));
  } catch {
    return false;
  }
}

/**
 * True when rendered inside preview canvas (`data-preview-canvas="true"`).
 * Used to make node UI read-only while still allowing viewing/copying.
 */
export function usePreviewCanvas(): boolean {
  const [isPreview, setIsPreview] = useState<boolean>(detectPreviewCanvas());

  useEffect(() => {
    // Keep in sync in case the preview container mounts after this component.
    setIsPreview(detectPreviewCanvas());
    const mo = new MutationObserver(() => {
      setIsPreview(detectPreviewCanvas());
    });
    try {
      mo.observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-preview-canvas'],
      });
    } catch {}
    return () => {
      try {
        mo.disconnect();
      } catch {}
    };
  }, []);

  return isPreview;
}


